/**
 * Whether a write succeeded, re-reading what it changed when it did.
 *
 * Any status but the one expected is a write that did not succeed. A caller that
 * tells one refusal from another reads the status before handing it here. A
 * write that rejects, with no status to read, is left to the caller.
 *
 * A re-read that fails does not undo a write the server accepted, so it is not
 * reported as one that failed — that would invite somebody to send it again.
 */
export const writeSucceeded = async (
  write: Promise<{ status: number }>,
  expected: number,
  reread: () => Promise<unknown>,
): Promise<boolean> => {
  if ((await write).status !== expected) {
    return false;
  }

  await reread().catch(() => undefined);
  return true;
};
